/**
 * Created by sebastienbeaujard on 26/04/2014.
 * Transaction server manager + retry feature
 */

angular.module('FlexyBeautyApp.services').
    factory('ServerSrv', ["$log","$timeout","MessageSrv","gettextCatalog","bugsnag","Constants","ErrorCode", "$rootScope",
        function ($log,$timeout,MessageSrv,gettextCatalog,bugsnag,Constants,ErrorCode,$rootScope) {

            var  serverSrv =
            {
                nextSavesStack : [],
                delay : 5000,
                promise : null,
                needToCleanMessage : false
            };
            serverSrv.addFunction =  function(functionToCall)
            {
                //Save function and parameters in order to be able to call it after current process
                var argumentsArray = Array.prototype.slice.apply(arguments);
                argumentsArray.splice(0,1);
                serverSrv.nextSavesStack.push({
                    functionToCall : functionToCall,
                    arguments : argumentsArray
                })
            };
            serverSrv.executeNextFunctionWithDelay=  function()
            {
                if (!serverSrv.promise)
                {
                    serverSrv.promise = $timeout(serverSrv.executeNextFunction,serverSrv.delay);
                    serverSrv.delay = serverSrv.delay*2;
                    if (serverSrv.delay>60000)
                        serverSrv.delay = 60000;
                }

            };
            serverSrv.executeNextFunction =  function()
            {
                if (serverSrv.promise)
                    serverSrv.promise = null;
                if (serverSrv.nextSavesStack.length!=0)
                {
                    console.log(new Date() + " executeNextFunction. Still " + serverSrv.nextSavesStack.length);
                    var saveFunction = serverSrv.nextSavesStack[0];//remove and assign value removed to saveFunction
                    saveFunction.functionToCall.apply(this, saveFunction.arguments);
                }
            };
            serverSrv.startSavingProcess =  function(functionToCall)
            {
                //Save function and parameters in order to be able to call it after current process
                var argumentsArray = Array.prototype.slice.apply(arguments);
                argumentsArray.splice(0,1);
                serverSrv.nextSavesStack.push({
                    functionToCall : functionToCall,
                    arguments : argumentsArray
                }) ;
                if (serverSrv.nextSavesStack.length==1)
                    serverSrv.executeNextFunction();
            };
            serverSrv.endSavingProcess = function(isSuccess, httpStatus, errorCode, bugsnagErrorNotification)
            {
                var mustRetry = false;
                if (isSuccess) {
                    if (serverSrv.needToCleanMessage) {
                        serverSrv.needToCleanMessage = false;
                        MessageSrv.cleanMessage();
                    }
                    serverSrv.delay = 5000;
                }
                else {
                    switch (httpStatus) {
                        case -1 :
                            MessageSrv.send("alert", "<span>" + gettextCatalog.getString("Connexion internet inactive") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Nouvelle tentative dans ") + serverSrv.delay / 1000 + "s");
                            mustRetry = true;
                            break;
                        case 200:
                            serverSrv.needToCleanMessage = true;
                            MessageSrv.send("error", "<span>" + gettextCatalog.getString("Votre sauvegarde a échoué à cause d'une erreur non identifiée.") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Il est conseillé de recharger.") + "</span>");
                            break;
                        case 401:
                            switch (errorCode) {
                                case ErrorCode.SESSION_TOKEN_INVALID.code:
                                    $rootScope.$emit("fxbInvalidToken");
                                    break;
                                case ErrorCode.CHANNEL_INVALID.code:
                                case ErrorCode.CHANNEL_EXPIRED.code:
                                    $rootScope.$emit("fxbInvalidChannel");
                                    break;
                                default :
                                    serverSrv.needToCleanMessage = true;
                                    MessageSrv.send("error", "<span>" + gettextCatalog.getString("Accès non autorisé") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Veuillez recharger ou vous reconnecter") + "</span>");
                                    break;
                            }
                            break;
                        case 403:
                            serverSrv.needToCleanMessage = true;
                            MessageSrv.send("error", "<span>" + gettextCatalog.getString("Accès non autorisé") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Veuillez vous reconnecter") + "</span>");
                            break;
                        case 409:
                            switch (errorCode) {
                                case ErrorCode.BOOKING_CONFLICT.code:
                                    serverSrv.needToCleanMessage = true;
                                    MessageSrv.send("error", "<span>" + gettextCatalog.getString("La réservation a été modifié par un autre utilisateur!") + "<br/>" + "<span>" + gettextCatalog.getString("Recharger pour mettre à jour") + "</span>");
                                    break;
                                case ErrorCode.SALE_CONFLICT.code:
                                    serverSrv.needToCleanMessage = true;
                                    MessageSrv.send("error", "<span>" + gettextCatalog.getString("Ce ticket a déjà été encaissé") + "<br/>" + "<span>" + gettextCatalog.getString("Recharger pour mettre à jour") + "</span>");
                                    break;
                                case ErrorCode.COMPANY_EMAIL_CONFLICT.code:
                                    serverSrv.needToCleanMessage = true;
                                    MessageSrv.send("error", "<span>" + gettextCatalog.getString("L'email fournit est déjà utilisé pour un autre compte ! L'email affiché n'est pas correct !") + "<br/>" + "<span>" + gettextCatalog.getString("Recharger l'admin pour éviter les erreurs !") + "</span>");
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 404:
                        case 412:
                        case 500:
                            serverSrv.needToCleanMessage = true;
                            MessageSrv.send("error", "<span>" + gettextCatalog.getString("Echec de la sauvegarde !") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Veuillez recharger la solution et essayer à nouveau.") + "</span>");
                            break;
                        default:
                            serverSrv.needToCleanMessage = true;
                            MessageSrv.send("error", "<span>" + gettextCatalog.getString("Erreur dans la sauvegarde code n°") + "</span>" + httpStatus + "<br/>" + "<span>" + gettextCatalog.getString("Veuillez recharger la solution et essayer à nouveau.") + "</span>");
                            break;
                    }
                    try {
                        if (bugsnagErrorNotification && serverSrv.nextSavesStack && serverSrv.nextSavesStack.length > 1) {
                            bugsnag.notify(bugsnagErrorNotification, "", {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
                        }
                    } catch(e){
                        //nothing to do
                    }
                }
                if (mustRetry) {
                    serverSrv.executeNextFunctionWithDelay();
                } else {
                    serverSrv.nextSavesStack.splice(0,1);
                    serverSrv.executeNextFunction();
                }
            };

            return serverSrv;

        }]);



// WEBPACK FOOTER //
// ./js/services/tools/ServerSrv.js